import React from "react";
import { appHost } from "../../helpers/uri";

const Loader = () => {
  return (
    <div style={{ width: "100%" }} className="text-center">
      <img src={`${appHost}/images/loading.gif`} alt="loader" style={{ maxWidth: 100 }} />
      <p className="text-center">Please wait... system loading</p>
    </div>
  );
};

export default Loader;
